<app-login-layout class="app-dark-theme">
  <main class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 col-md-7 offset-md-5 col-lg-6 offset-lg-6 px-5">
        <app-register-carrier [invite]="false"></app-register-carrier>
      </div>
    </div>
  </main>
</app-login-layout>

